export enum LOCAL_METHOD {
    local = 'LOCAL_STORAGE',
    session = 'SESSION_STORAGE'
}